import { Box } from "@mui/material";
import { ReactNode } from "react";

interface SignupSplitLayoutProps {
  children: ReactNode;
}

const SignupSplitLayout = ({ children }: SignupSplitLayoutProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        overflow: "hidden",
        mt: 4,
        maxWidth: { xs: "90%", lg: "1030px" },
        mx: "auto",
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: "16px",
        boxShadow: 3,
        bgcolor: "white",
        // p: { xs: 3, sm: 4 },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", lg: "50%" },
          display: "flex",
          flexDirection: "column",
          bgcolor: "white",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {children}
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "none", lg: "flex" },
          minHeight: "300px",
          width: "50%",
          alignItems: "center",
          justifyContent: "center",
          pl: 2,
          py: 3,
          bgcolor: "#EEF5FF",
        }}
      >
        <Box
          component="img"
          src="/images/signupBanner.webp"
          alt="signup banner"
          sx={{
            width: "100%",
            borderRadius: "16px",
          }}
        />
      </Box>
    </Box>
  );
};

export default SignupSplitLayout;
